import React, { useEffect, useRef, useState } from 'react'
import Hexapi from '../../utility/HexAPI/Hexapi'
import { useSelector } from 'react-redux';
import Meetingheader from './Meetingheader';
import Meetinglist from './Meetinglist';
import Loader from '../../components/loader/Loader';
import "./meeting.css"
import { useMemo } from 'react';
import Meetingdetails from './Meetingdetails';

const Meetings = () => {

  const user = useSelector(state => state?.users?.data?.[""]?.[0]);
  const userid = user?.empid ?? null;
  const [mode, setmode] = useState(0);
  const [searching, setSearching] = useState(false);
  const [search, setSearch] = useState("");
  const [meetingID, setMeetingID] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pendingMeetings, setPendingMeetings] = useState([]);
  const [closedMeetings, setClosedMeetings] = useState([]);
  const [isInfo,setisInfo] = useState(false)
const latestModeRef = useRef(mode);
  useEffect(() => {
  latestModeRef.current = mode;
}, [mode]);
  const getMeetingListData = async () => {
  const currentMode = mode; 

  const obj = {
    query: `HRApp_Droid_Proc_User_Meeting_GetList @UserID='{0}', @mode='{1}'`,
    queryArr: [`${userid}`, `${currentMode}`]
  };

  try {
    setLoading(true);

    const resp = await Hexapi(obj, () => getMeetingListData(), 1, 0);

    if (latestModeRef.current !== currentMode) {
      return; 
    }

    const data = resp && resp[""] ? resp[""] : [];

    if (currentMode === 0) {
      setPendingMeetings(data);
    } else {
      setClosedMeetings(data);
    }

  } catch (error) {
    console.error("Meeting List Error:", error);
  } finally {
    if (latestModeRef.current === currentMode) {
      setLoading(false);
    }
  }
};
const currentList = mode === 0 ? pendingMeetings : closedMeetings;
const filteredMeetings = useMemo(() => {
  return currentList.filter(item => {
    if (!search.trim()) return true;
    return item?.name?.toLowerCase().includes(search.toLowerCase());
  });
}, [currentList, search]);
  useEffect(() => {
    if (!userid) return;
    getMeetingListData();
  }, [userid, mode]);


  const GetMeetingDetails = async (id) => {
  setMeetingID(id)
    };
  return (
    <div className='container-fluid mt-3'>
      <div className='row'>
        <div className='col-3'>
          <div className="meeting-header-fixed">
            <Meetingheader
              setmode={setmode}
              mode={mode}
              search={search}
              setSearch={setSearch}
              searching={searching}
              setSearching={setSearching}
            />
          </div>
          
          <div className="meeting-box mt-2 " >
            {loading ? (
              <div className="d-flex justify-content-center align-items-center"
  style={{ height: "78vh", color: "#ff6d00" }}>
                <Loader />
              </div>
            ) : filteredMeetings.length > 0 ? (
              <Meetinglist list={filteredMeetings}  GetMeetingDetails={(id)=>{GetMeetingDetails(id)}} meetingid={meetingID}/>
            ) : (
              <div 
  className="d-flex justify-content-center align-items-center"
  style={{ height: "78vh", color: "#ff6d00" }}
>
  {search ? "No Search Results Found" : "No Meetings!"}
</div>
            )}
          </div>

        </div>

        <div className={isInfo ? "col-3" : "col-9"} style={{paddingLeft:"0px"}}>
          <div className='meeting-box-right'>
           {
            meetingID ? <Meetingdetails setisInfo={(data)=>setisInfo(data)} meetingid={meetingID}  userid={userid}/> : <div 
  className="d-flex justify-content-center align-items-center"
  style={{ height: "90vh", color: "#ff6d00" }}>
  Select a meeting to view details
</div>
           }
          </div>
        </div>
{
  isInfo && <div className='col-3 meeting-box' style={{paddingLeft:"0px"}}>

    </div>
}
       
      </div>
    </div>
  );
};

export default Meetings;